// SAD-459 (LIB-01) — TanStack Query bindings for the Library discovery home.
// Both scopes (Discover / My items) share ONE search RPC (zou's
// SearchLibraryItems) and differ only in the `scope` filter field
// ("" = discovery, "owner" = the viewer's own drafts/history) — see
// services/zou/pkg/connecthandlers/library.go.
import { Timestamp } from '@bufbuild/protobuf';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { projectDataClient } from '../../lib/connect/clients';
export const LIBRARY_SEARCH_KEY = 'library-search';
function toTs(d) {
    return d ? Timestamp.fromDate(d) : undefined;
}
/** Searches Library items for one scope. Server drops anything the viewer may not see. */ export function useSearchLibraryItems(scope, filters) {
    return useQuery({
        queryKey: [
            LIBRARY_SEARCH_KEY,
            scope,
            filters
        ],
        queryFn: async ()=>{
            const resp = await projectDataClient.searchLibraryItems({
                filter: {
                    scope,
                    query: filters.query ?? '',
                    itemType: filters.itemType ?? '',
                    customerAgencyName: filters.customerAgencyName ?? '',
                    providerCompanyProfileId: filters.providerCompanyProfileId ?? '',
                    scopeContext: filters.scopeContext ?? '',
                    capabilityContext: filters.capabilityContext ?? '',
                    status: filters.status ?? '',
                    updatedSince: toTs(filters.updatedSince)
                },
                offset: 0,
                limit: 50
            });
            return resp.items;
        }
    });
}
/** Creates a Library item. The server always stamps status=draft and owner=viewer. */ export function useCreateLibraryItem() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: async (args)=>{
            const resp = await projectDataClient.createLibraryItem({
                title: args.title,
                summary: args.summary ?? '',
                itemType: args.itemType,
                customerAgencyName: args.customerAgencyName ?? '',
                providerCompanyProfileId: args.providerCompanyProfileId ?? '',
                scopeContext: args.scopeContext ?? '',
                capabilityContext: args.capabilityContext ?? '',
                preparedContent: args.preparedContent ?? '',
                preparedContentFormat: 'plain_text'
            });
            if (!resp.item) throw new Error('CreateLibraryItem returned no item');
            return resp.item;
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    LIBRARY_SEARCH_KEY
                ]
            });
        },
        onError: (err)=>{
            toast.error(err instanceof Error ? err.message : 'Failed to create Library item');
        }
    });
}
